import Api from './Api';

const END_POINT = 'units';

export default {
    get_all (filters) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    }
}